<!-- Ensure you have imported ng-bootstrap and bootstrap in your Angular project -->
<div class="my-3 p-3 align-self-center d-flex flex-column align-items-center">
  <!-- Card for Benutzerverwaltung -->
  <a routerLink="/admin/users" class="btn btn-qundis-primary mb-2 w-100">
    <div
      class="button-labeling d-flex d-row align-items-center justify-content-center p-3"
    >
      <div class="icon-container mx-3">
        <i [ngClass]="BootstrapIcon.users" class="h2"></i>
      </div>
      <div class="text-container">
        <h4 class="button-text font-base">Benutzerverwaltung</h4>
      </div>
    </div>
  </a>

  <!-- Card for Arbeitsplatzverwaltung -->
  <a routerLink="/admin/workstations" class="btn btn-qundis-primary my-2 w-100">
    <div
      class="button-labeling d-flex d-row align-items-center justify-content-center p-3"
    >
      <div class="icon-container mx-3">
        <i [ngClass]="BootstrapIcon.workstations" class="h2"></i>
      </div>
      <div class="text-container">
        <h4 class="button-text font-base">Arbeitsplatzverwaltung</h4>
      </div>
    </div>
  </a>
  <!-- Card for Produktionslinienverwaltung -->
  <a routerLink="/admin/productionLines" class="btn btn-qundis-warn my-2 w-100">
    <div
      class="button-labeling d-flex d-row align-items-center justify-content-center p-3"
    >
      <div class="icon-container mx-3">
        <i [ngClass]="BootstrapIcon.productionLines" class="h2"></i>
      </div>
      <div class="text-container">
        <h4 class="button-text font-base">Produktionslinienverwaltung</h4>
      </div>
    </div>
  </a>
  <!-- Verwaltung Auto-Logout -->
  <div class="my-3 w-100" style="background-color: #ededed; border-radius: 6px">
    <div class="my-3 w-100">
      <span
        class="title w-100 ps-4 text-start font-base btn"
        style="pointer-events: none"
        >Automatischer Logout</span
      >
    </div>
    <div class="my-2 mb-4 w-100 ps-4">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <button
            class="btn bg-qundis-secundary-light font-16"
            style="background-color: #f8f8f8"
            (click)="toggleLogoutInput()"
          >
            Logout bearbeiten (HH:mm)
          </button>
          <input
            type="time"
            [formControl]="timeoutControl"
            class="auto-logout mx-3"
            [value]="secondsToHHmm(userService.sessionTimeout()!)"
          />
          <i
            [class]="
              timeoutControl.enabled ? 'bi bi-unlock-fill' : 'bi bi-lock-fill'
            "
          ></i>
        </div>
        <div *ngIf="timeoutControl.enabled" class="d-flex my-3">
          <button
            class="confirm-input btn btn-qundis-primary btn-sm m-1 d-flex align-items-center"
            (click)="updateSessionTimeout()"
          >
            <span>Speichern</span>
            <i class="bi bi-check h5"></i>
          </button>
          <button
            class="cancel-input btn btn-qundis-secundary btn-sm m-1 d-flex align-items-center"
            (click)="cancel()"
          >
            <span>Verwerfen</span>
            <i class="bi bi-x h5"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
